import { StyleSheet } from 'aphrodite';
import { inputBorderColor } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	dropdownContentInnerOverrides: {
		borderColor: inputBorderColor,
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
		borderTopRightRadius: 0,
		maxHeight: '700px !important',
	},
	dropdownMenuOverrides: {
		maxHeight: '700px !important',
	},
	policyTypeRadioButtons: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
	},
});
